// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vuetify from '@/plugins/vuetify' // path to vuetify export

/* Import the firebase SDK and extend with firestore */
import firebase from 'firebase/app';
require('firebase/firestore');
require('firebase/auth');

const config = {
  apiKey: "AIzaSyAlZ-9-GZwgKCs0k4VW7DEYF59SWiRog0I",
  authDomain: "izzulsyahmi.com",
  databaseURL: "https://portfolio-izzul-syahmi.firebaseio.com",
  projectId: "portfolio-izzul-syahmi",
  storageBucket: "portfolio-izzul-syahmi.appspot.com",
  messagingSenderId: "572148482007",
  appId: "1:572148482007:web:34d9734dfb0ad29d639592",
  measurementId: "G-T9HC0C9TQC"
};

/* Initialize firebase with your configuration */
firebase.initializeApp(config);

/* Bind firebase to your Vue instance */
Vue.prototype.$firebase = firebase;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  vuetify,
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js